<!--
 * Path: src/core/components/floatingPanel/FloatingPanelList.vue
 * Task: Render the scrollable list content area for the floating panel, using strict TypeScript.
-->
<template>
  <div class="panel-content flex-grow-1 overflow-y-auto">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
/**
 * Path: src/core/components/floatingPanel/FloatingPanelList.vue
 * Task: Scaffolding wrapper.
 */
</script>
